import { render, staticRenderFns } from "./ReportePonencia.vue?vue&type=template&id=33add07c&scoped=true"
import script from "./ReportePonencia.vue?vue&type=script&lang=js"
export * from "./ReportePonencia.vue?vue&type=script&lang=js"
import style0 from "./ReportePonencia.vue?vue&type=style&index=0&id=33add07c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33add07c",
  null
  
)

export default component.exports